//import router from "@/router";
import Cookies from "js-cookie";
import { getUrlParams, initLocalName } from "@/utils";
import { Cats } from "@/api/user";
import { db } from "@/db";

const state = {
  API_TOKEN:
    process.env.NODE_ENV == "development" ? process.env.VUE_APP_API_TOKEN : "", //getToken(),
  chatId: '',
  chatStatus: {
    chatId: '',
    status: '',
  },
  loginInfo: null,
  homeInputValue: '',
  menuData: [],
  isMobile: false,
  asideData: [],
  kfImgUrl: '',
  isJdUser: false
};

const mutations = {
  SET_API_TOKEN: (state, data) => {
    state.API_TOKEN = data;
  },
  SET_CHAT_ID: (state, data) => {
    state.chatId = data;
  },
  SET_CHAT_STATUS: (state, data) => {
    state.chatStatus = data;
  },
  SET_LOGIN_INFO: (state, data) => {
    state.loginInfo = data;
  },
  SET_HOME_INPUT_VALUE: (state, data) => {
    state.homeInputValue = data;
  },
  SET_MENU_DATA: (state, data) => {
    state.menuData = data;
  },
  SET_ISMOBILE: (state, data) => {
    state.isMobile = data;
  },
  SET_ASIDEDATA: (state, data) => {
    state.asideData = data;
  },
  SET_KFIMGURL: (state, data) => {
    state.kfImgUrl = data;
  },
  SET_ISJDUSER: (state, data) => {
    state.isJdUser = data;
  },
};

const actions = {
  changeApiToken({ commit, dispatch }, data) {
    commit("SET_API_TOKEN", data);
  },
  changeChatId({ commit, dispatch }, data) {
    commit("SET_CHAT_ID", data);
  },
  changeChatStatus({ commit, dispatch }, data) {
    commit("SET_CHAT_STATUS", data);
  },
  changeLoginInfo({ commit, dispatch }, data) {
    commit("SET_LOGIN_INFO", data);
  },
  changeHomeInputValue({ commit, dispatch }, data) {
    commit("SET_HOME_INPUT_VALUE", data);
  },
  changeMenuData({ commit, dispatch }, data) {
    commit("SET_MENU_DATA", data);
  },
  changeIsMobile({ commit, dispatch }, data) {
    commit("SET_ISMOBILE", data);
  },
  changeAsideData({ commit, dispatch }, data) {
    commit("SET_ASIDEDATA", data);
  },
  changeKfImgUrl({ commit, dispatch }, data) {
    commit("SET_KFIMGURL", data);
  },
  changeIsJdUser({ commit, dispatch }, data) {
    commit("SET_ISJDUSER", data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
